import React, { forwardRef } from "react";

import "../assets/css/sandwich.css";

const Sandwich = forwardRef(function Sandwich({ onClick, expanded }, ref) {
  return (
    <button
      ref={ref}
      className="sandwich"
      onClick={onClick}
      aria-label={expanded ? "Close menu" : "Open menu"}
      aria-expanded={expanded}
    >
      <div></div>
      <div></div>
      <div></div>
    </button>
  );
});

export default Sandwich;
